export default {
  language_selector: {
    label: 'Wybierz język',
  },
  nav_items: {
    home: 'Strona główna',
    menu: 'Menu',
    locations: 'Lokalizacje',
    store_info: 'O sklepie',
    rewards: 'Nagrody',
  },
};
